<div class="modal">
  <app-modal-header [title]="data.title" icon="verified_user"
    closeLabel="Close verification code" (closed)="cancel()"></app-modal-header>
  <div class="modal-body">
    <p class="mb-2">{{ data.description }}</p>
    <ng-container [formGroup]="form">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Verification code</mat-label>
        <input
          matInput
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="6"
          placeholder="Enter the 6-digit code"
          formControlName="code"
          (input)="normalizeCode()"
        />
        <mat-error *ngIf="form.get('code')?.hasError('required')">The verification code is required</mat-error>
        <mat-error *ngIf="form.get('code')?.hasError('pattern')">Enter a valid 6-digit code</mat-error>
      </mat-form-field>
    </ng-container>
  </div>
  <div class="hr mb-1 mt-2"></div>
  <div class="modal-footer text-end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="confirm()" [disabled]="form.invalid">
      {{ data.confirmButtonText }}
    </button>
  </div>
</div>
